<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.7384 6.35157C17.8237 6.2515 17.928 6.16923 18.0451 6.10944C18.1623 6.04966 18.2901 6.01354 18.4212 6.00314C18.5523 5.99274 18.6842 6.00826 18.8093 6.04883C18.9344 6.0894 19.0503 6.15421 19.1504 6.23957C19.2504 6.32493 19.3327 6.42916 19.3925 6.54632C19.4523 6.66347 19.4884 6.79126 19.4988 6.92238C19.5092 7.05349 19.4937 7.18537 19.4531 7.31049C19.4126 7.4356 19.3477 7.5515 19.2624 7.65157L10.7624 17.6516C10.6761 17.753 10.5705 17.8362 10.4517 17.8963C10.3329 17.9564 10.2032 17.9921 10.0704 18.0015C9.93759 18.0108 9.80424 17.9935 9.67819 17.9506C9.55214 17.9076 9.43594 17.84 9.33638 17.7516L4.83638 13.7516C4.63813 13.5753 4.51801 13.3276 4.50245 13.0628C4.48688 12.798 4.57715 12.5378 4.75338 12.3396C4.92962 12.1413 5.17739 12.0212 5.44219 12.0056C5.70699 11.9901 5.96713 12.0803 6.16538 12.2566L9.90038 15.5726L17.7384 6.35157Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

withDefaults(defineProps<CbIconProps>(), cbIconDefaults);
</script>
